module.exports = __webpack_public_path__ + "img/yandex.def6627b.svg";